"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveRoundScoreArrayIndexForRound = resolveRoundScoreArrayIndexForRound;
/**
 * Index of `roundScores[idx]` for a 1-based round number.
 * Prefer `roundNumber` on each round-score object; fall back to array index (round 1 → 0).
 */
function resolveRoundScoreArrayIndexForRound(roundScores, roundNumber) {
    if (!Array.isArray(roundScores) || roundScores.length === 0)
        return -1;
    const rn = Number(roundNumber);
    if (!Number.isFinite(rn) || rn < 1)
        return -1;
    const byField = roundScores.findIndex((r) => r != null && Number(r.roundNumber) === rn);
    if (byField >= 0)
        return byField;
    const byIdx = rn - 1;
    return byIdx >= 0 && byIdx < roundScores.length ? byIdx : -1;
}
